<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="名称">
              <a-input v-model="filterForm.name" placeholder="名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="false" :span="6">
            <a-form-model-item label="分类">
              <a-input v-model="filterForm.category" placeholder="分类" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="6">
                <a-form-model-item label="与我相关">
                  <a-radio-group v-model="filterForm.about" button-style="solid" @change="onSearch">
                    <a-radio-button value="all"> 全部 </a-radio-button>
                    <a-radio-button value="about"> 与我相关 </a-radio-button>
                    <a-radio-button value="aboutTeam"> 团队相关 </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
          </a-col> -->
          <a-col :span="6" class="filter-right">
            <a-button type="primary" @click="getArtifactList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="制品仓库列表" class="filter-data">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
        <span slot="category" slot-scope="text, record">
          <a-avatar shape="square" icon="team" :src="record.logo" class="table-image" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:artifact:version:list', project: 0 }" @click="onDetail(record)">查看</a>
        </span>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import { artifactList } from '@/api/system/artifact';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '类别',
    dataIndex: 'category',
    key: 'category',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'category' }
  },
  {
    title: '名称',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: '25%'
  },
  {
    title: '描述',
    key: 'description',
    dataIndex: 'description',
    ellipsis: true,
    width: '25%'
  },
  {
    title: '关联服务名称',
    dataIndex: 'service_name',
    key: 'service_name',
    ellipsis: true
  },
  {
    title: '操作',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  data() {
    return {
      loading: false,
      filterForm: {
        name: null,
        category: null,
        page_number: 1,
        page_size: 10
      },
      paramForm: {
        about: 'all',
        time_field: 'created_time',
        fields: []
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      columns
    };
  },
  created() {
    this.getArtifactList();
  },
  methods: {
    reset() {
      this.filterForm = {
        name: null,
        category: null,
        page_size: this.pagination.pageSize,
        page_number: 1
      };
      this.getArtifactList();
    },

    getArtifactList() {
      artifactList(this.filterForm).then(res => {
        this.tableData = res.data.items;
        this.pagination.total = res.data.total;
      });
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getArtifactList();
    },

    onSearch() {
      this.filterForm.page_number = 1;
      this.getArtifactList();
    },

    onDetail(record) {
      this.$router.push({
        name: 'page:project:cicd:artifact:version',
        query: { artifactId: record.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
</style>
